export default {
  create_title: 'Ajouter un point de terminaison webhook',
  edit_title: 'Modifier le point de terminaison webhook',
  form: {
    url: 'URL du point de terminaison HTTPS',
    description: 'Description',
    description_placeholder: 'ex. Événements de commande pour le POS',
    events: 'Événements à livrer',
    events_required: 'Sélectionnez au moins un événement.',
    events_hint: 'Seuls les événements sélectionnés sont envoyés à ce point de terminaison.',
    events_selected: '{{selected}} sur {{total}}',
    event_groups: {
      order: 'Commandes',
      store: 'Boutique',
      product: 'Produits',
      modifier: 'Modificateurs',
      menu_push: 'Envois de menu',
      payout: 'Paiements',
    },
    status: 'Statut',
    status_active: 'Actif',
    status_disabled: 'Désactivé',
    status_auto_disabled: 'Désactivé automatiquement (choisissez Actif pour réactiver)',
  },
  buttons: {
    cancel: 'Annuler',
    create: 'Créer',
    save: 'Enregistrer',
  },
  toasts: {
    created: 'Point de terminaison créé.',
    updated: 'Point de terminaison mis à jour.',
    error: "Impossible d'enregistrer le point de terminaison. Veuillez réessayer.",
  },
};
